import { z } from "@/zod";

/** Short weekday keys for the schedule form; order is Monday → Sunday (aligned with Luxon `weekday` 1–7). */
export const SCHEDULE_FORM_WEEKDAY_KEYS = [
  "Mo",
  "Tu",
  "We",
  "Th",
  "Fr",
  "Sa",
  "Su",
] as const;

export type ScheduleFormWeekdayKey =
  (typeof SCHEDULE_FORM_WEEKDAY_KEYS)[number];

export const scheduleFormWeekdaysSchema = z
  .object({
    Mo: z.boolean(),
    Tu: z.boolean(),
    We: z.boolean(),
    Th: z.boolean(),
    Fr: z.boolean(),
    Sa: z.boolean(),
    Su: z.boolean(),
  })
  .refine((weekdays) => SCHEDULE_FORM_WEEKDAY_KEYS.some((k) => weekdays[k]), {
    message: "validation.weekdays_at_least_one",
  });
